/*
AJAXy business to handle cached environment
*/

function onHaveUserData() {
	var data = JSON.parse(sessionStorage.getItem('rd_user_data'));
	var dataLayer = window.dataLayer || [];

	// show stuff based on logged in status
	if (data.loggedIn) {
		$('.logged-in-show').removeClass('logged-in-show');
		$('#logged-in-as').text(data.email);
		dataLayer.push({
			'userEmail' : data.email
		});
	} else {
		$('.logged-out-show').removeClass('logged-out-show');
	}

	// show stuff based on cart count
	if (data.cartCount === 0) {
		$('.empty-cart-show').removeClass('empty-cart-show');
		$('.cart-count').text('').removeClass('has-items');
	} else {
		$('.filled-cart-show').removeClass('filled-cart-show');
		$('.cart-count').text(data.cartCount).addClass('has-items');
	}

	// show stuff based on membership
	if (data.membership) {
		$('.has-membership-show').removeClass('has-membership-show');
		$('#current-plan-name').text(data.membership);
	}
	if (data.hasPremium) {
		$('.any-premium-show').removeClass('any-premium-show');
	} else {
		$('.no-premium-show').removeClass('no-premium-show');
	}
	if (data.hasHandicapperPicksOnly) {
		$('.has-capper-picks-show').removeClass('has-capper-picks-show');
	}

}

function fetchUserData() {
	$.ajax({
		method: 'post',
		url: "/wp-admin/admin-ajax.php",
		data: {
			'action': 'rd_get_user_data'
		},
		success: function (data) {
			sessionStorage.setItem('rd_user_data', data);
			onHaveUserData();
		}
	});
}

if (sessionStorage.getItem('rd_user_data')) {
	// already have data from previous page load
	onHaveUserData();
} else {
	// fetch user info
	fetchUserData();
}

$b.on('updated_cart_totals wc_cart_emptied', function () {
	sessionStorage.removeItem('rd_user_data');
	fetchUserData();
});